import {AxiosRequestConfig} from 'axios'
import RequestBase from '../../../api/RequestBase'

const BASE_URL = '/agreements'

const getClaim = (config?: AxiosRequestConfig | undefined) => {
  return RequestBase.get(`${BASE_URL}/claim`, config)
}

const storeClaim = (payload: any, config?: AxiosRequestConfig | undefined) => {
  return RequestBase.post(`${BASE_URL}/claim`, payload, config)
}

const updateHazmat = (payload: any, config?: AxiosRequestConfig | undefined) => {
  return RequestBase.put(`${BASE_URL}/hazmat`, payload, config)
}

const AgreementService = {
  //Claim
  getClaim,
  storeClaim,

  //Hazmat
  updateHazmat,
}

export default AgreementService
